import Uiconstants from '../../lib/UIconstants';
import DoubleChanceController from '../../controllers/double_chance/DoubleChanceController';
import { COMPONENTS } from '../../lib/constants';

let scale = 0.676;
export const DoubleChanceWidgetMobile = {
	name: COMPONENTS.DOUBLE_CHANCE_WIDGET,
	tmp: 'mobile',
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: DoubleChanceController,
			name: 'DoubleChanceController',
			config: {
				item: Uiconstants.FTR_DOUBLE_CHANCE,
				holder: 'double_chance_widget_holder_up'
			}
		}
	],
	components: [
		{
			name: 'double_chance_widget_holder_up',
			type: 'Sprite',
			position: { x: 0, y: 0 },
			components: [
				{
					name: 'double_wrapper',
					type: 'ActionButton',
					components: [
						{
							name: 'double_chance_widget_bg_mobile',
							type: 'MouseOverSprite',
							img: 'double_chance_widget_bg_mobile',
							imgHover: 'double_chance_widget_bg_mobile',
							cursor: 'default',
							position: { x: 20, y: -15 },
							components: [
								{
									name: Uiconstants.FTR_DOUBLE_CHANCE,
									type: 'SwitchButton',
									bgimg: 'double_chance_switcher_icon_on',
									bg: 'double_chance_switcher_bg_on',
									fgimg: 'double_chance_switcher_icon_off',
									fg: 'double_chance_switcher_bg_off',
									bgText: 'DOUBLE_CHANCE_SWITCHER_ON',
									fgText: 'DOUBLE_CHANCE_SWITCHER_OFF'
								}
							]
						},
						{
							name: 'bg',
							type: 'Sprite',
							components: [
								{
									name: 'border_passive_top',
									type: 'AnimatedSprite',
									position: { x: -22, y: -22 },
									animation: {
										pattern: 'Passive_Frame_000$.png',
										start: 0,
										end: 24,
										speed: 0.5,
										loop: true,
										precision: 2,
										scale: {
											x: scale,
											y: scale
										}
									}
								},
								// {
								// 	name: 'border_active_top',
								// 	type: 'AnimatedSprite',
								// 	position: { x: -22, y: -25 },
								// 	animation: {
								// 		pattern: 'Active_Frame_000$.png',
								// 		start: 0,
								// 		end: 23,
								// 		speed: 0.5,
								// 		loop: true,
								// 		precision: 2,
								// 		scale: {
								// 			x: scale,
								// 			y: scale
								// 		}
								// 	}
								// },
								{
									name: 'border_passive_bottom',
									type: 'AnimatedSprite',
									position: { x: -22, y: 55 },
									animation: {
										pattern: 'Passive_Frame_000$.png',
										start: 0,
										end: 24,
										speed: 0.5,
										loop: true,
										precision: 2,
										rotation: 3.14159,
										anchor: {
											x: 1,
											y: 1
										},
										scale: {
											x: scale,
											y: scale
										}
									}
								}
								// {
								// 	name: 'border_active_bottom',
								// 	type: 'AnimatedSprite',
								// 	position: { x: -22, y: 55 },
								// 	animation: {
								// 		pattern: 'Active_Frame_000$.png',
								// 		start: 0,
								// 		end: 23,
								// 		speed: 0.5,
								// 		loop: true,
								// 		precision: 2,
								// 		rotation: 3.14159,
								// 		anchor: {
								// 			x: 1,
								// 			y: 1
								// 		},
								// 		scale: {
								// 			x: scale,
								// 			y: scale
								// 		}
								// 	}
								// }
							]
						},

						{
							name: 'DOUBLE_CHANCE_VALUE',
							type: 'Text',
							position: { x: 27, y: 5 },
							text: 'UI_DOUBLE_CHANCE_VALUE'
						},
						{
							name: 'DOUBLE_CHANCE_TITLE',
							type: 'Text',
							position: { x: 27, y: 55 },
							text: 'UI_DOUBLE_CHANCE_TITLE'
						},
						{
							name: 'DOUBLE_CHANCE_CURRENCY',
							type: 'Text',
							position: { x: 27, y: 25 },
							text: 'DOUBLE_CHANCE_CURRENCY'
						},
						{
							name: 'DOUBLE_CHANCE_SUBTITLE',
							type: 'Text',
							position: { x: 93, y: 80.5 - 13 },
							text: 'UI_DOUBLE_CHANCE_SUBTITLE'
						}
					]
				}
			]
		}
	]
};
